function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreVertical = function SvgMoreVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "navigation/more-vertical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 12C13.75 12.9665 12.9665 13.75 12 13.75C11.0335 13.75 10.25 12.9665 10.25 12C10.25 11.0335 11.0335 10.25 12 10.25C12.9665 10.25 13.75 11.0335 13.75 12Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 4C13.75 4.9665 12.9665 5.75 12 5.75C11.0335 5.75 10.25 4.9665 10.25 4C10.25 3.0335 11.0335 2.25 12 2.25C12.9665 2.25 13.75 3.0335 13.75 4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 20C13.75 20.9665 12.9665 21.75 12 21.75C11.0335 21.75 10.25 20.9665 10.25 20C10.25 19.0335 11.0335 18.25 12 18.25C12.9665 18.25 13.75 19.0335 13.75 20Z",
    fill: "currentColor"
  }))));
};
SvgMoreVertical.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMoreVertical"
};
export default SvgMoreVertical;